import { render, staticRenderFns } from "./GenerationLimits.vue?vue&type=template&id=19699351&"
import script from "./GenerationLimits.vue?vue&type=script&lang=js&"
export * from "./GenerationLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports